import React from "react"
import classnames from "classnames"
import * as inputs from "inputs"
import * as bglayouts from "brandguard/components/layouts"
import DocumentDropwell from "./dropwell"

export default function Upload(
	props: React.PropsWithChildren<{
		statistics: inputs.uploads.api.statistics
		concurrent: number
		background: string
		onChange: (item: File[], background?: string) => void
	}>,
): JSX.Element {
	const { children, background, onChange } = props

	return (
		<>
			<DocumentDropwell
				className={classnames("documents", "upload", bglayouts.uploads.navdropwellsimple)}
				mb="20px"
				onChange={(files) => onChange(files, background)}
			/>
			{children}
		</>
	)
}
